export var ClearConnectionResults;
(function (ClearConnectionResults) {
    ClearConnectionResults["RemovedConnection"] = "RemovedConnection";
    ClearConnectionResults["QueryNotFound"] = "QueryNotFound";
})(ClearConnectionResults || (ClearConnectionResults = {}));
//# sourceMappingURL=index.js.map